<template>
    <div id="app">
        <site-header />
        <router-view />
        <site-footer />
        <el-dialog
                v-if="member"
                title="賬戶詳情"
                :visible="showAccountDetailDialog"
                width="50%"
                @close="set_account_detail_dialog(false)"
        >
            <ul>
                <li>Member ID: {{ member.code }}</li>
                <li>賬戶電郵: {{ member.email }}</li>
                <li>名字: {{ member.firstname }} {{ member.lastname }}</li>
                <li>電話：{{ member.phone_area_code }} {{ member.phone }}</li>
                <li class="c-green">賬戶餘額：{{ member.balance }}</li>
                <li class="c-blue">賬戶積分：{{ member.integral }}</li>
                <li class="c-gray" style="font-size: 1.5em">
                    <router-link :to="{ name: 'referrals' }" @click.native="set_account_detail_dialog(false)">
                        介紹Uniports給朋友，賺取積分
                    </router-link>
                </li>
            </ul>
        </el-dialog>
    </div>
</template>

<script>

  import { mapGetters, mapState, mapMutations } from 'vuex';
  import SiteHeader from '@/components/SiteHeader';
  import SiteFooter from '@/components/SiteFooter';
  import { TOKEN_EXPIRE_NOTICE_KEY } from './constants';

  // require('jquery-goup/src/jquery.goup');

  // /* global $ */

  export default {
    name: 'App',
    mounted() {
      // $.goup({
      //   trigger: 100,
      //   bottomOffset: 50,
      //   locationOffset: 10,
      //   title: '回到頂部',
      //   titleAsText: false,
      //   hideUnderWidth: 0,
      // });
      this.$store.dispatch('loadTokenFromLocalStore').then(() => {
        if (this.isLogined && this.currentMember.status === 2) {
          this.$router.push({ path: '/activation-your-account' });
        }
      }).catch(() => {
        this.$store.dispatch('logout');
      });
      this.$store.dispatch('fetchSettings');
      this.$store.dispatch('fetchWarehouse');
      this.$store.dispatch('uaParse');
      // 每分鐘運行的任務定時器
      setInterval(() => {
        // 檢查是否需要刷新token
        if (sessionStorage.getItem(TOKEN_EXPIRE_NOTICE_KEY)) {
          this.$store.dispatch('refreshToken').then(() => {
            sessionStorage.removeItem(TOKEN_EXPIRE_NOTICE_KEY);
          });
        }
      }, 60000);
    },
    computed: {
      ...mapGetters([
        'isLogined',
        'currentMember',
      ]),
      ...mapState({
        member: state => state.member.identity,
        showAccountDetailDialog: state => state.app.showAccountDetailDialog,
      }),
    },
    methods: {
      ...mapMutations(['set_account_detail_dialog']),
    },
    components: {
      SiteHeader,
      SiteFooter,
    },
  };
</script>



// WEBPACK FOOTER //
// src/App.vue